import { render, staticRenderFns } from "./basicDetails.vue?vue&type=template&id=8c15dedc&"
import script from "./basicDetails.vue?vue&type=script&lang=js&"
export * from "./basicDetails.vue?vue&type=script&lang=js&"
import style0 from "./basicDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports